import useAlias from '@hooks/useAlias';
import { Button, DialogActions } from '@mui/material';
import React from 'react';
import {
  useDataPointSearchActions,
  useDataPointSearchState,
} from '../context/DataPointSearchContext';
import { SelectedDataPoint } from '../types';

interface SelectionActionsProps {
  onClose: () => void;
  onAddDataPoints: (dataPoints: SelectedDataPoint[]) => void;
}

const SelectionActions: React.FC<SelectionActionsProps> = ({
  onClose,
  onAddDataPoints,
}) => {
  const alias = useAlias();
  const state = useDataPointSearchState();
  const { getSelectedDataPoints, resetState } = useDataPointSearchActions();

  const selectedCount = state.selection.size;

  const handleAdd = () => {
    const selectedDataPoints = getSelectedDataPoints();
    if (selectedDataPoints.length > 0) {
      onAddDataPoints(selectedDataPoints);
      resetState();
      onClose();
    }
  };

  const handleCancel = () => {
    resetState();
    onClose();
  };

  return (
    <DialogActions>
      <Button onClick={handleCancel}>{alias('Cancel')}</Button>
      <Button
        onClick={handleAdd}
        disabled={selectedCount === 0}
        variant='contained'
        color='primary'
      >
        {alias('Add Selected')}
      </Button>
    </DialogActions>
  );
};

export default SelectionActions;
